"use client";

import { ArrowDown, ArrowUp, FileIcon, X } from "lucide-react";
import { formatBytes } from "@/lib/utils";

/** Seçilen dosyaların listesi; sıralama ve silme kontrolleriyle. */
export function FileList({
  files,
  onChange,
  reorderable = true,
}: {
  files: File[];
  onChange: (files: File[]) => void;
  reorderable?: boolean;
}) {
  function move(i: number, delta: number) {
    const j = i + delta;
    if (j < 0 || j >= files.length) return;
    const next = [...files];
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  }

  if (!files.length) return null;

  return (
    <ul className="space-y-2">
      {files.map((f, i) => (
        <li
          key={`${f.name}-${i}`}
          className="flex items-center gap-3 rounded-xl border border-border bg-surface px-4 py-3"
        >
          <FileIcon className="size-4 shrink-0 text-muted" />
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium">{f.name}</p>
            <p className="text-xs text-muted">{formatBytes(f.size)}</p>
          </div>

          {reorderable && files.length > 1 && (
            <div className="flex gap-1">
              <button
                type="button"
                onClick={() => move(i, -1)}
                disabled={i === 0}
                aria-label="Yukarı taşı"
                className="grid size-8 place-items-center rounded-lg text-muted transition hover:bg-surface-muted disabled:opacity-30"
              >
                <ArrowUp className="size-4" />
              </button>
              <button
                type="button"
                onClick={() => move(i, 1)}
                disabled={i === files.length - 1}
                aria-label="Aşağı taşı"
                className="grid size-8 place-items-center rounded-lg text-muted transition hover:bg-surface-muted disabled:opacity-30"
              >
                <ArrowDown className="size-4" />
              </button>
            </div>
          )}

          <button
            type="button"
            onClick={() => onChange(files.filter((_, k) => k !== i))}
            aria-label="Kaldır"
            className="grid size-8 place-items-center rounded-lg text-muted transition hover:bg-rose-500/10 hover:text-rose-500"
          >
            <X className="size-4" />
          </button>
        </li>
      ))}
    </ul>
  );
}
